module.exports = __webpack_public_path__ + "img/face-downcast-sweat.8eab9c23.svg";